<prlw-buy-product-ui
  [instrument]="instrument"
  [status]="buyProductStatus$ | async"
  [destinations]="destinations$ | async"
  [currentDestination]="currentDestination$ | async"
  (stationChange)="updateStationList($event)"
  (buyRequest)="buyRequest($event)"
  (repeatBuyRequest)="repeatBuyRequest()"
  (setCurrentDestination)="setCurrentDestination($event)"
  (closeOverlay)="closeModal()"
  (eventOpenDestinationsOverlay)="handleOpenDestinationsOverlay()"
>
</prlw-buy-product-ui>
